import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the type for the Event Bus State
interface EventBusState {
  [event: string]: any;
}

const initialState: EventBusState = {};

// Create a slice for managing business events
const eventBusSlice = createSlice({
  name: "eventBus",
  initialState,
  reducers: {
    // Set an event in the event bus state
    setEvent: (state, action: PayloadAction<{ event: string; value: any }>) => {
      const { event, value } = action.payload;
      state[event] = value;
    },
    // Clear a specific event
    clearEvent: (state, action: PayloadAction<{ event: string }>) => {
      const { event } = action.payload;
      delete state[event];
    },
    // Clear all events (if needed)
    clearAllEvents: () => initialState,
  },
});

export const { setEvent, clearEvent, clearAllEvents } = eventBusSlice.actions;

export default eventBusSlice.reducer;
